export class ToastViewModel {
    Type: string;
    Title: string;
    Message: string;
    LinkText: string;
    LinkURL: string;

    constructor () {
        this.Type = '';
        this.Title = '';
        this.Message = '';
        this.LinkText = '';
        this.LinkURL = '';
    }
}
